import { render, staticRenderFns } from "./logisticsList.vue?vue&type=template&id=86d06ee0&"
import script from "./logisticsList.vue?vue&type=script&lang=js&"
export * from "./logisticsList.vue?vue&type=script&lang=js&"
import style0 from "./logisticsList.vue?vue&type=style&index=0&id=86d06ee0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports